import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useMemo } from 'react';

import { InactivePhoneNumberWarningPopupController } from './inactive-phone-number-warning-popup.controller';

const InactivePhoneNumberWarningPopupModal = NiceModal.create(InactivePhoneNumberWarningPopupController);

export const useInactivePhoneNumberWarningPopup = () => {
  const { show } = useModal(InactivePhoneNumberWarningPopupModal);
  return useMemo(() => ({ open: show }), [show]);
};
